export const REWARD_POINT_TYPE = {
  DEFAULT: 'default',
  BUSINESS: 'business',
  BUSINESSRRP: 'businessrrp',
  EXPERT: 'expert',
  CERTIFICATE: 'certificate',
}
